// Per-route SEO metadata (es / en / sk) for the RE₿EL BTC site.
// Used by /app/frontend/src/components/SEO.jsx.
// To add a new route: add a key here matching the pageKey prop you'll pass to <SEO />.

export const SITE_URL = "https://www.rebelbtc.com";
export const OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_polyglot-trendia-web/artifacts/iq86or1f_ChatGPT%20Image%2029%20may%202026%2C%2011_45_11.png";
export const SITE_NAME = "RE₿EL BTC · Academia RE₿EL";

// Path -> pageKey. Used by SEO.jsx to auto-detect from location when no prop is provided.
export const PATH_TO_KEY = {
  "/": "home",
  "/liquidity-map": "liquidity_map",
  "/academy": "academy",
  "/simulator": "simulator",
  "/simulator/play": "simulator_play",
  "/simulator/results": "simulator_results",
  "/simulator/history": "simulator_history",
  "/simulator/leaderboard": "simulator_leaderboard",
  "/terms": "terms",
  "/privacy": "privacy",
  "/contact": "contact",
  "/payment-success": "payment_success",
  "/blog": "blog",
  "/shadow": "shadow",
};

// Pages that must NOT be indexed (auth-required, dynamic state, payment success).
export const NOINDEX_KEYS = new Set([
  "simulator_play",
  "simulator_results",
  "simulator_history",
  "payment_success",
  "shadow",
]);

const t = {
  es: {
    home: {
      title: "RE₿EL Academy | Liquidity Map · Trading IA · Academia Crypto | rebelbtc.com",
      description:
        "7 herramientas crypto en una plataforma. Liquidity Map con 27 exchanges + DeFi + Ballenas, TrendIA, Academia, Shadow Network, R₿L Token y TopWallet. En español, inglés y eslovaco.",
      keywords:
        "academia trading cripto, liquidity map bitcoin, mapa liquidaciones, curso bitcoin español, TrendIA IA trading, shadow network, R₿L token, DeFi crypto, RE₿EL BTC",
      path: "/",
    },
    liquidity_map: {
      title: "Liquidity Map BTC ETH SOL | 27 Exchanges + DeFi + Ballenas | RE₿EL",
      description:
        "El único mapa de liquidaciones que agrega 27 exchanges CEX+DEX, datos DeFi on-chain (Aave, Morpho) y detector de ballenas >$1M. Predictor IA de cascadas en tiempo real. Alternativa gratuita a CoinGlass.",
      keywords:
        "liquidity map bitcoin, mapa liquidaciones crypto, heatmap liquidaciones BTC, predictor cascada bitcoin, detector ballenas crypto, DeFi liquidaciones aave, CoinGlass alternativa, liquidaciones tiempo real",
      path: "/liquidity-map",
    },
    academy: {
      title: "Curso Trading Cripto | 6 Niveles de Principiante a Quant | Academia RE₿EL",
      description:
        "51 lecciones estructuradas en 6 niveles de trading de criptomonedas. Smart Money Concepts, análisis técnico, gestión de riesgo y Mentor IA Claude Sonnet 4.5. Empieza gratis.",
      keywords:
        "curso trading criptomonedas, curso bitcoin gratis, smart money concepts español, análisis técnico bitcoin, mentor IA trading, academia rebel",
      path: "/academy",
    },
    simulator: {
      title: "RE₿EL Market Simulator™ | Simula Trading Cripto en Tiempo Real | Academia RE₿EL",
      description:
        "Practica trading sin riesgo real. Revive el colapso de FTX, ETF approval, COVID crash y liquidity sweeps. IA Mentor en vivo + Trader DNA™ psicológico. Prueba gratis.",
      keywords:
        "simulador trading cripto, simulador bitcoin gratis, market simulator, trader dna, smart money trap, simulador FTX",
      path: "/simulator",
    },
    simulator_leaderboard: {
      title: "Leaderboard Global | Mejores Traders del RE₿EL Market Simulator™",
      description:
        "Top 10 traders RE₿EL con mejor PnL en cada simulación. Compite globalmente — rankings semanales y all-time desde RETAIL SURVIVOR hasta MARKET PREDATOR.",
      keywords: "leaderboard trading cripto, ranking traders, market simulator ranking, RE₿EL traders",
      path: "/simulator/leaderboard",
    },
    terms: {
      title: "Términos y Condiciones | RE₿EL BTC · Academia RE₿EL",
      description:
        "Condiciones de uso de la plataforma RE₿EL BTC, la Academia RE₿EL y el Mentor IA. Contenido exclusivamente educativo — no es asesoramiento financiero.",
      keywords: "términos condiciones rebel btc, condiciones uso academia rebel",
      path: "/terms",
    },
    privacy: {
      title: "Política de Privacidad | RE₿EL BTC",
      description:
        "Cómo recogemos, usamos y protegemos tus datos personales en RE₿EL BTC. Conforme al RGPD. Pagos vía Stripe, IA vía Anthropic, autenticación opcional con Google.",
      keywords: "política privacidad rebel btc, RGPD academia trading",
      path: "/privacy",
    },
    contact: {
      title: "Contacto | RE₿EL BTC · Soporte de la Academia",
      description:
        "Escríbenos a rebelbtc@rebelbtc.com. Soporte de la Academia, Mentor IA, pagos y soporte técnico. Respondemos en menos de 48 horas hábiles.",
      keywords: "contacto rebel btc, soporte academia rebel, rebelbtc@rebelbtc.com",
      path: "/contact",
    },
    simulator_play: { title: "Simulación en vivo | RE₿EL Market Simulator™", description: "Sesión de simulación activa.", keywords: "", path: "/simulator/play" },
    simulator_results: { title: "Resultados | RE₿EL Market Simulator™", description: "Resultados de tu simulación y Trader DNA™.", keywords: "", path: "/simulator/results" },
    simulator_history: { title: "Mi historial | RE₿EL Market Simulator™", description: "Tu historial completo de simulaciones (PRO).", keywords: "", path: "/simulator/history" },
    payment_success: { title: "Pago confirmado · RE₿EL PRO", description: "Activación de tu licencia PRO.", keywords: "", path: "/payment-success" },
    blog: {
      title: "Blog RE₿EL | Trading, Bitcoin y Cripto sin humo | Academia RE₿EL",
      description:
        "Guías largas y honestas sobre Bitcoin, trading de criptomonedas, análisis técnico y psicología del mercado. Escrito por traders, sin clickbait.",
      keywords:
        "blog bitcoin español, blog trading cripto, aprender trading blog, análisis técnico bitcoin, psicología trading",
      path: "/blog",
    },
    shadow: {
      title: "SHADOW NETWORK™ | Red de Operadores RE₿EL | rebelbtc.com",
      description: "Red de reclutamiento institucional. Codename operativo, sistema de XP y rango, desbloqueo por reputación.",
      keywords: "", path: "/shadow",
    },
  },
  en: {
    home: {
      title: "RE₿EL Academy | Liquidity Map · AI Trading · Crypto Academy | rebelbtc.com",
      description:
        "7 crypto tools in one platform. Liquidity Map with 27 exchanges + DeFi + Whales, TrendIA, Academy, Shadow Network, R₿L Token and TopWallet. In Spanish, English and Slovak.",
      keywords:
        "crypto trading academy, liquidity map bitcoin, liquidation heatmap, bitcoin course english, TrendIA AI trading, shadow network, R₿L token, DeFi crypto, REBEL Academy",
      path: "/",
    },
    liquidity_map: {
      title: "Liquidity Map BTC ETH SOL | 27 Exchanges + DeFi + Whales | RE₿EL",
      description:
        "The only liquidation map aggregating 27 CEX+DEX exchanges, on-chain DeFi data (Aave, Morpho) and whale detector >$1M. AI cascade predictor in real time. Free CoinGlass alternative.",
      keywords:
        "liquidity map bitcoin, crypto liquidation heatmap, BTC liquidations real time, cascade predictor AI, whale detector crypto, DeFi liquidations aave, CoinGlass alternative, liquidation map free",
      path: "/liquidity-map",
    },
    shadow: {
      title: "Shadow Network | Social Trading & Encrypted Chat | RE₿EL",
      description:
        "Social trading network with encrypted messaging, monthly USDC competitions and analyst subscriptions. Exclusive to RE₿EL PRO members.",
      keywords:
        "social trading network, shadow network crypto, trading community, encrypted chat crypto",
      path: "/shadow",
    },
    academy: {
      title: "Crypto Trading Course | 6 Levels Beginner to Quant | RE₿EL Academy",
      description:
        "51 structured lessons across 6 levels of crypto trading. Smart Money Concepts, technical analysis, risk management and Claude Sonnet 4.5 AI Mentor. Start free.",
      keywords: "crypto trading course, free bitcoin course, smart money concepts, AI mentor trading, RE₿EL academy",
      path: "/academy",
    },
    simulator: {
      title: "RE₿EL Market Simulator™ | Realtime Crypto Trading Simulation | RE₿EL Academy",
      description:
        "Practice trading risk-free. Relive the FTX collapse, ETF approval, COVID crash and liquidity sweeps. Live AI Mentor + psychological Trader DNA™. Try free.",
      keywords: "crypto trading simulator, free bitcoin simulator, market simulator, trader dna, smart money trap, FTX simulator",
      path: "/simulator",
    },
    simulator_leaderboard: {
      title: "Global Leaderboard | Best Traders of RE₿EL Market Simulator™",
      description: "Top 10 RE₿EL traders with the best PnL each simulation. Compete globally — weekly and all-time rankings from RETAIL SURVIVOR to MARKET PREDATOR.",
      keywords: "trading leaderboard crypto, top traders ranking, market simulator ranking, RE₿EL traders",
      path: "/simulator/leaderboard",
    },
    terms: { title: "Terms & Conditions | RE₿EL BTC", description: "Terms of use of the RE₿EL BTC platform, RE₿EL Academy and AI Mentor. Educational content only — not financial advice.", keywords: "terms conditions rebel btc", path: "/terms" },
    privacy: { title: "Privacy Policy | RE₿EL BTC", description: "How we collect, use and protect your data at RE₿EL BTC. GDPR-compliant. Stripe payments, Anthropic AI, optional Google authentication.", keywords: "privacy policy rebel btc", path: "/privacy" },
    contact: { title: "Contact | RE₿EL BTC · Academy Support", description: "Email us at rebelbtc@rebelbtc.com. Academy, AI Mentor, payment and technical support. We reply within 48 business hours.", keywords: "contact rebel btc, academy support", path: "/contact" },
    simulator_play: { title: "Live Simulation | RE₿EL Market Simulator™", description: "Active simulation session.", keywords: "", path: "/simulator/play" },
    simulator_results: { title: "Results | RE₿EL Market Simulator™", description: "Your simulation results and Trader DNA™.", keywords: "", path: "/simulator/results" },
    simulator_history: { title: "My history | RE₿EL Market Simulator™", description: "Full simulation history (PRO).", keywords: "", path: "/simulator/history" },
    payment_success: { title: "Payment confirmed · RE₿EL PRO", description: "PRO licence activation.", keywords: "", path: "/payment-success" },
    blog: {
      title: "RE₿EL Blog | Trading, Bitcoin & Crypto without the noise | RE₿EL Academy",
      description:
        "Long, honest guides on Bitcoin, crypto trading, technical analysis and market psychology. Written by traders, no clickbait.",
      keywords:
        "bitcoin blog, crypto trading blog, learn trading blog, technical analysis bitcoin, trading psychology",
      path: "/blog",
    },
  },
  sk: {
    home: {
      title: "RE₿EL Akadémia | Liquidity Map · AI Trading · Crypto Akadémia | rebelbtc.com",
      description: "7 crypto nástrojov na jednej platforme. Liquidity Map s 27 burzami + DeFi + Veľryby, TrendIA, Akadémia, Shadow Network, R₿L Token a TopWallet. V španielčine, angličtine a slovenčine.",
      keywords: "crypto trading akadémia, liquidity map bitcoin, mapa likvidácií, bitcoin kurz slovensky, TrendIA AI trading, shadow network, R₿L token",
      path: "/",
    },
    liquidity_map: {
      title: "Liquidity Map BTC ETH SOL | 27 Búrz + DeFi + Veľryby | RE₿EL",
      description:
        "Jediná mapa likvidácií agregujúca 27 CEX+DEX búrz, on-chain DeFi dáta (Aave, Morpho) a detektor veľrýb >$1M. AI prediktor kaskád v reálnom čase. Bezplatná alternatíva CoinGlass.",
      keywords:
        "liquidity map bitcoin, mapa likvidácií crypto, BTC likvidácie reálny čas, prediktor kaskád AI, detektor veľrýb crypto, DeFi likvidácie aave",
      path: "/liquidity-map",
    },
    academy: { title: "Krypto Trading Kurz | 6 Úrovní | RE₿EL Akadémia", description: "51 štruktúrovaných lekcií v 6 úrovniach krypto tradingu. Smart Money Concepts, technická analýza, riadenie rizika a Claude Sonnet 4.5 AI Mentor. Začni zdarma.", keywords: "krypto trading kurz, bitcoin kurz zdarma, smart money concepts, AI mentor trading, RE₿EL akadémia", path: "/academy" },
    simulator: { title: "RE₿EL Market Simulator™ | Simuluj Crypto Trading v Reálnom Čase", description: "Cvič trading bez rizika. Prežij FTX kolaps, ETF approval, COVID crash a liquidity sweeps. Živý AI Mentor + psychologická Trader DNA™. Skús zdarma.", keywords: "krypto trading simulátor, bitcoin simulátor zdarma, market simulator, trader dna, FTX simulátor", path: "/simulator" },
    simulator_leaderboard: { title: "Globálny Leaderboard | Najlepší Traderi RE₿EL Market Simulator™", description: "Top 10 RE₿EL traderov s najlepším PnL. Súťaž globálne — týždenné a celkové rebríčky od RETAIL SURVIVOR po MARKET PREDATOR.", keywords: "trading leaderboard krypto, top traderi ranking, RE₿EL traderi", path: "/simulator/leaderboard" },
    terms: { title: "Podmienky používania | RE₿EL BTC", description: "Podmienky používania platformy RE₿EL BTC, RE₿EL Akadémie a AI Mentora. Iba vzdelávací obsah — nie finančné poradenstvo.", keywords: "podmienky rebel btc", path: "/terms" },
    privacy: { title: "Zásady ochrany súkromia | RE₿EL BTC", description: "Ako zhromažďujeme, používame a chránime tvoje údaje. V súlade s GDPR. Stripe platby, Anthropic AI, voliteľná Google autentifikácia.", keywords: "zásady súkromia rebel btc", path: "/privacy" },
    contact: { title: "Kontakt | RE₿EL BTC · Podpora Akadémie", description: "Napíš nám na rebelbtc@rebelbtc.com. Akadémia, AI Mentor, platby a technická podpora. Odpovedáme do 48 pracovných hodín.", keywords: "kontakt rebel btc, podpora akadémie", path: "/contact" },
    simulator_play: { title: "Živá simulácia | RE₿EL Market Simulator™", description: "Aktívna relácia simulácie.", keywords: "", path: "/simulator/play" },
    simulator_results: { title: "Výsledky | RE₿EL Market Simulator™", description: "Výsledky a Trader DNA™.", keywords: "", path: "/simulator/results" },
    simulator_history: { title: "Moja história | RE₿EL Market Simulator™", description: "Kompletná história simulácií (PRO).", keywords: "", path: "/simulator/history" },
    payment_success: { title: "Platba potvrdená · RE₿EL PRO", description: "Aktivácia PRO licencie.", keywords: "", path: "/payment-success" },
    blog: {
      title: "RE₿EL Blog | Trading, Bitcoin & Krypto bez šumu | RE₿EL Akadémia",
      description:
        "Dlhé, čestné návody o Bitcoine, krypto tradingu, technickej analýze a psychológii trhu. Písané tradermi, bez clickbaitu.",
      keywords:
        "bitcoin blog, krypto trading blog, naučiť sa trading, technická analýza bitcoin, psychológia trading",
      path: "/blog",
    },
    shadow: { title: "SHADOW NETWORK™ | RE₿EL Sieť Operátorov", description: "Inštitucionálna náborová sieť. Codename, XP, hodnosti, tajné odomykania.", keywords: "", path: "/shadow" },
  },
  de: {
    home: {
      title: "RE₿EL Academy | Liquidity Map · Trading IA · Crypto-Akademie | rebelbtc.com",
      description: "7 Crypto-Tools in einer Plattform. Liquidity Map mit 27 Exchanges + DeFi + Wale, TrendIA, Akademie, Shadow Network, R₿L Token und TopWallet. Auf Deutsch, Englisch und Slowakisch.",
      keywords: "crypto trading akademie, liquidity map bitcoin, liquidationskarte, bitcoin kurs deutsch, TrendIA KI trading, shadow network, R₿L token, DeFi crypto, RE₿EL BTC",
      path: "/",
    },
    liquidity_map: {
      title: "Liquidity Map BTC ETH SOL | 27 Exchanges + DeFi + Wale | RE₿EL",
      description: "Die einzige Liquidationskarte, die 27 CEX+DEX-Exchanges, DeFi-On-Chain-Daten (Aave, Morpho) und Wal-Detektor >$1M aggregiert. KI-Kaskaden-Prädiktor in Echtzeit. Kostenlose CoinGlass-Alternative.",
      keywords: "liquidity map bitcoin, crypto liquidationskarte, BTC liquidations heatmap, bitcoin kaskaden prädiktor, crypto wal detektor, DeFi liquidationen aave, CoinGlass alternative, echtzeit liquidationen",
      path: "/liquidity-map",
    },
    academy: {
      title: "Crypto Trading Kurs | 6 Level von Anfänger bis Quant | RE₿EL Akademie",
      description: "51 strukturierte Lektionen in 6 Trading-Levels für Kryptowährungen. Smart Money Concepts, technische Analyse, Risikomanagement und KI-Mentor Claude Sonnet 4.5. Starte kostenlos.",
      keywords: "kryptowährung trading kurs, bitcoin kurs kostenlos, smart money concepts deutsch, bitcoin technische analyse, KI trading mentor, rebel akademie",
      path: "/academy",
    },
    simulator: {
      title: "RE₿EL Market Simulator™ | Simuliere Crypto Trading in Echtzeit | RE₿EL Akademie",
      description: "Übe Trading ohne echtes Risiko. Erlebe den FTX-Kollaps, ETF-Approval, COVID-Crash und Liquidity Sweeps nach. Live-KI-Mentor + psychologisches Trader DNA™. Teste kostenlos.",
      keywords: "crypto trading simulator, bitcoin simulator kostenlos, market simulator, trader dna, smart money trap, FTX simulator",
      path: "/simulator",
    },
    simulator_leaderboard: {
      title: "Globales Leaderboard | Beste Trader des RE₿EL Market Simulator™",
      description: "Top 10 RE₿EL Trader mit bestem PnL in jeder Simulation. Konkurriere global — wöchentliche und All-Time-Rankings von RETAIL SURVIVOR bis MARKET PREDATOR.",
      keywords: "crypto trading leaderboard, trader ranking, market simulator ranking, RE₿EL traders",
      path: "/simulator/leaderboard",
    },
    terms: {
      title: "Allgemeine Geschäftsbedingungen | RE₿EL BTC · RE₿EL Akademie",
      description: "Nutzungsbedingungen der RE₿EL BTC Plattform, der RE₿EL Akademie und des KI-Mentors. Ausschließlich Bildungsinhalte — keine Finanzberatung.",
      keywords: "agb rebel btc, nutzungsbedingungen rebel akademie",
      path: "/terms",
    },
    privacy: {
      title: "Datenschutzerklärung | RE₿EL BTC",
      description: "Wie wir deine persönlichen Daten auf RE₿EL BTC sammeln, verwenden und schützen. DSGVO-konform. Zahlungen via Stripe, KI via Anthropic, optionale Authentifizierung mit Google.",
      keywords: "datenschutzerklärung rebel btc, DSGVO trading akademie",
      path: "/privacy",
    },
    contact: {
      title: "Kontakt | RE₿EL BTC · Akademie-Support",
      description: "Schreib uns an rebelbtc@rebelbtc.com. Akademie-Support, KI-Mentor, Zahlungen und technischer Support. Wir antworten innerhalb von 48 Werktagen.",
      keywords: "kontakt rebel btc, rebel akademie support, rebelbtc@rebelbtc.com",
      path: "/contact",
    },
    simulator_play: {
      title: "Live-Simulation | RE₿EL Market Simulator™",
      description: "Aktive Simulationssitzung.",
      keywords: "",
      path: "/simulator/play",
    },
    simulator_results: {
      title: "Ergebnisse | RE₿EL Market Simulator™",
      description: "Ergebnisse deiner Simulation und Trader DNA™.",
      keywords: "",
      path: "/simulator/results",
    },
    simulator_history: {
      title: "Mein Verlauf | RE₿EL Market Simulator™",
      description: "Dein vollständiger Simulationsverlauf (PRO).",
      keywords: "",
      path: "/simulator/history",
    },
    payment_success: {
      title: "Zahlung bestätigt · RE₿EL PRO",
      description: "Aktivierung deiner PRO-Lizenz.",
      keywords: "",
      path: "/payment-success",
    },
    blog: {
      title: "RE₿EL Blog | Trading, Bitcoin und Crypto ohne Hype | RE₿EL Akademie",
      description: "Ausführliche und ehrliche Guides zu Bitcoin, Kryptowährungs-Trading, technischer Analyse und Marktpsychologie. Von Tradern geschrieben, ohne Clickbait.",
      keywords: "bitcoin blog deutsch, crypto trading blog, trading lernen blog, bitcoin technische analyse, trading psychologie",
      path: "/blog",
    },
    shadow: {
      title: "SHADOW NETWORK™ | RE₿EL Operator Network | rebelbtc.com",
      description: "Institutionelles Rekrutierungsnetzwerk. Operativer Codename, XP- und Rang-System, Freischaltung durch Reputation.",
      keywords: "",
      path: "/shadow",
    },
  },
  "zh-CN": {
    home: {
      title: "RE₿EL Academy | 流动性地图 · 交易 IA · 加密学院 | rebelbtc.com",
      description: "一个平台集成7种加密工具。流动性地图覆盖27个交易所 + DeFi + 巨鲸，TrendIA，学院，Shadow Network，R₿L Token 和 TopWallet。支持西班牙语、英语和斯洛伐克语。",
      keywords: "加密交易学院，比特币流动性地图，强制平仓地图，比特币课程西班牙语，TrendIA AI交易，shadow network，R₿L token，DeFi加密，RE₿EL BTC",
      path: "/",
    },
    liquidity_map: {
      title: "流动性地图 BTC ETH SOL | 27个交易所 + DeFi + 巨鲸 | RE₿EL",
      description: "唯一聚合27个CEX+DEX交易所、链上DeFi数据（Aave、Morpho）和>$1M巨鲸检测器的强制平仓地图。实时AI连环爆仓预测器。CoinGlass的免费替代品。",
      keywords: "比特币流动性地图，加密强制平仓地图，BTC强制平仓热图，比特币连环爆仓预测器，加密巨鲸检测器，DeFi强制平仓aave，CoinGlass替代品，实时强制平仓",
      path: "/liquidity-map",
    },
    academy: {
      title: "加密交易课程 | 从初学者到Quant的6个级别 | RE₿EL学院",
      description: "51节课程，分为6个加密货币交易级别。Smart Money Concepts、技术分析、风险管理和AI导师Claude Sonnet 4.5。免费开始。",
      keywords: "加密货币交易课程，免费比特币课程，smart money concepts西班牙语，比特币技术分析，AI交易导师，rebel学院",
      path: "/academy",
    },
    simulator: {
      title: "RE₿EL Market Simulator™ | 实时加密交易模拟 | RE₿EL学院",
      description: "无真实风险的交易练习。重现FTX崩盘、ETF批准、COVID暴跌和流动性扫荡。实时AI导师 + Trader DNA™心理分析。免费试用。",
      keywords: "加密交易模拟器，免费比特币模拟器，市场模拟器，trader dna，smart money陷阱，FTX模拟器",
      path: "/simulator",
    },
    simulator_leaderboard: {
      title: "全球排行榜 | RE₿EL Market Simulator™最佳交易者",
      description: "每次模拟中PnL最佳的前10名RE₿EL交易者。全球竞争——从RETAIL SURVIVOR到MARKET PREDATOR的每周和历史排名。",
      keywords: "加密交易排行榜，交易者排名，市场模拟器排名，RE₿EL交易者",
      path: "/simulator/leaderboard",
    },
    terms: {
      title: "条款与条件 | RE₿EL BTC · RE₿EL学院",
      description: "RE₿EL BTC平台、RE₿EL学院和AI导师的使用条款。纯教育内容——非财务建议。",
      keywords: "rebel btc条款条件，rebel学院使用条款",
      path: "/terms",
    },
    privacy: {
      title: "隐私政策 | RE₿EL BTC",
      description: "我们如何收集、使用和保护您在RE₿EL BTC上的个人数据。符合GDPR。通过Stripe支付，通过Anthropic提供AI，可选Google身份验证。",
      keywords: "rebel btc隐私政策，交易学院GDPR",
      path: "/privacy",
    },
    contact: {
      title: "联系我们 | RE₿EL BTC · 学院支持",
      description: "发送邮件至rebelbtc@rebelbtc.com。学院支持、AI导师、支付和技术支持。我们将在48个工作小时内回复。",
      keywords: "联系rebel btc，rebel学院支持，rebelbtc@rebelbtc.com",
      path: "/contact",
    },
    simulator_play: {
      title: "实时模拟 | RE₿EL Market Simulator™",
      description: "活跃模拟会话。",
      keywords: "",
      path: "/simulator/play",
    },
    simulator_results: {
      title: "结果 | RE₿EL Market Simulator™",
      description: "您的模拟结果和Trader DNA™。",
      keywords: "",
      path: "/simulator/results",
    },
    simulator_history: {
      title: "我的历史记录 | RE₿EL Market Simulator™",
      description: "您的完整模拟历史记录（PRO）。",
      keywords: "",
      path: "/simulator/history",
    },
    payment_success: {
      title: "支付确认 · RE₿EL PRO",
      description: "您的PRO许可证激活。",
      keywords: "",
      path: "/payment-success",
    },
    blog: {
      title: "RE₿EL博客 | 交易、比特币和加密货币无烟雾 | RE₿EL学院",
      description: "关于比特币、加密货币交易、技术分析和市场心理的长篇诚实指南。由交易者撰写，无标题党。",
      keywords: "西班牙语比特币博客，加密交易博客，学习交易博客，比特币技术分析，交易心理",
      path: "/blog",
    },
    shadow: {
      title: "SHADOW NETWORK™ | RE₿EL操作员网络 | rebelbtc.com",
      description: "机构招募网络。代号操作，XP和等级系统，声誉解锁。",
      keywords: "",
      path: "/shadow",
    },
  },
};

export const SEO_BY_ROUTE = t;

export const getSeoMeta = (pageKey, lang) => {
  const langDict = t[lang] || t.es;
  return langDict[pageKey] || langDict.home;
};
